import React from "react"
import { FieldAutomationTriggerFormProps } from "../../../../../render/automation-trigger-form"
import SelectMultiGenericNew from "../../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new";

const debug = false
// const debug = "FieldTaskTypes_AutomationTriggerForm"

export default class FieldTaskTypes_AutomationTriggerForm extends React.Component<FieldAutomationTriggerFormProps,any> {


    constructor(props:FieldAutomationTriggerFormProps) {
        super(props)

        this.state = {
            fromValues       : _.get(props.config, 'fromValues', null),
            toValues         : _.get(props.config, 'toValues', null)
        }

    }

    onChangeFromValues = (fromValues:any) => {
         this.setState({
             fromValues
         }, ()=>{
             this.props.onChangeCallback({fromValues})
         })
    }

    onChangeToValues = (toValues:any) => {
        this.setState({
            toValues
        }, ()=>{
            this.props.onChangeCallback({toValues})
        })
    }

    render() {
    debug && console.log(debug, 'render', this.state)

        return (
            <div className="flex-row-left-top">
                <div className="label">from</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                    options                          = {this.props.field.getAutomationOptions()}
                                    values                           = {this.state.fromValues}
                                    allValuesOptionLabel             = "Any"
                                    popoverScrollContainerClasses    = "max-h-200"
                                    allValuesOption                  = {true}
                                    isSearchable                     = {true}
                                    disabled                         = {this.props.config.disabled}
                                    onChange                         = {this.onChangeFromValues}/>

                <div className="label">to</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                    options                          = {this.props.field.getAutomationOptions()}
                                    values                           = {this.state.toValues}
                                    allValuesOptionLabel             = "Any"
                                    popoverScrollContainerClasses    = "max-h-200"
                                    allValuesOption                  = {true}
                                    isSearchable                     = {true}
                                    disabled                         = {this.props.config.disabled}
                                    onChange                         = {this.onChangeToValues}/>
            </div>
        )
    }

}


